var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plv-product-bubble"},[_c('div',{staticClass:"c-product-bubble"},[(_vm.productSdk)?_c('product-bubble',{attrs:{"product-sdk":_vm.productSdk,"lang":_vm.lang,"getLinkParams":_vm.getLinkParams},on:{"click-buy":_vm.handleClickBuy}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }